import { Layers, Server, Boxes, Cpu, MemoryStick, HardDrive } from 'lucide-react';
import { StatCardGrid, type StatCardItem } from '../cloud/stat-card-grid';

/**
 * Cloud Resources headline stat cards — the compute/storage counterpart to
 * `PhysicalStatCards`, built on the shared `StatCardGrid` so both dashboard tabs
 * (and the zone drill-down) read as one system.
 */
export interface CloudStatCardsProps {
  zoneCount: number;
  healthyZones: number;
  totalHosts: number;
  healthyHosts: number;
  totalVms: number;
  cpuPct: number;
  memoryPct: number;
  storagePct: number;
}

/** 6-up grid of cloud headline metrics with colored corner icons. */
export function CloudStatCards(p: CloudStatCardsProps) {
  const cards: StatCardItem[] = [
    { label: 'Total Zones', value: p.zoneCount, hint: `${p.healthyZones} healthy · compute`, icon: Layers, color: 'var(--vn-primary-solid)' },
    { label: 'Total Hosts', value: p.totalHosts, hint: `${p.healthyHosts} healthy`, icon: Server, color: 'var(--vn-success-solid)' },
    { label: 'Total VMs', value: p.totalVms, hint: 'Running instances', icon: Boxes, color: 'var(--vn-accent-solid)' },
    { label: 'CPU Usage', value: `${p.cpuPct}%`, hint: 'Average utilization', icon: Cpu, color: 'var(--vn-warning-solid)' },
    { label: 'Memory Usage', value: `${p.memoryPct}%`, hint: 'Average utilization', icon: MemoryStick, color: 'var(--vn-danger-solid)' },
    { label: 'Storage Usage', value: `${p.storagePct}%`, hint: 'Total capacity used', icon: HardDrive, color: 'var(--vn-info-solid)' },
  ];
  return <StatCardGrid items={cards} />;
}
